'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _ = _interopRequireWildcard(_lodash);

var _body = require('./body');

var _body2 = _interopRequireDefault(_body);

var _headers = require('./headers');

var _headers2 = _interopRequireDefault(_headers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 @module response
 */

var initKeys = ['status', 'statusText', 'type', 'cacheState', 'httpsState', 'headers', 'url', 'urlList', 'terminationReason'];

var Response = function (_Body) {
  _inherits(Response, _Body);

  function Response() {
    var body = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
    var init = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    _classCallCheck(this, Response);

    var defaults = {
      status: 200,
      statusText: 'OK',
      type: 'default',
      cacheState: 'none',
      httpsState: 'none',
      headers: {}
    };

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Response).call(this, body));

    if (!_.isPlainObject(init)) throw new Error('Response init must be an object');

    if (!_.isNumber(init.status) && !_.isUndefined(init.status)) throw new Error('Response init.status must be a number');

    if (!_.isString(init.type) && !_.isUndefined(init.type)) throw new Error('Response init.type must be a string');

    if (!_.isString(init.statusText) && !_.isUndefined(init.statusText)) throw new Error('Response init.statusText must be a string');

    if (!_.isArray(init.urlList) && !_.isUndefined(init.urlList)) throw new Error('Response init.urlList must be an array');

    if (!_.isString(init.terminationReason) && !_.isUndefined(init.terminationReason)) throw new Error('Response init.terminationReason must be a string');

    if (!_.isString(init.cacheState) && !_.isUndefined(init.cacheState)) throw new Error('Response init.cacheState must be a string');

    if (!_.isString(init.httpsState) && !_.isUndefined(init.httpsState)) throw new Error('Response init.httpsState must be a string');

    _.extend(_this, defaults, _.pick(init, initKeys));

    _this._body = body;

    _this.ok = _this.status >= 200 && _this.status < 300;

    _this.headers = new _headers2.default(init.headers);

    _this.headerList = _this.headers.map;

    if (_.isString(init.url) && !_.isArray(init.urlList)) _this.url = decodeURIComponent(init.url);

    if (_.isArray(init.urlList)) {

      _this.urlList = _.map(init.urlList, decodeURIComponent);
      _this.url = _.last(_this.urlList);
    }

    return _this;
  }

  _createClass(Response, [{
    key: 'clone',
    value: function clone() {

      return new Response(this._body, _.pick(this, initKeys));
    }
  }, {
    key: 'error',
    value: function error() {

      return new Response('', {
        type: 'error',
        status: 0,
        statusText: 'Network Error'
      });
    }
  }, {
    key: 'redirect',
    value: function redirect() {

      throw new Error('Method has not been implemented by farfetchd yet');
    }
  }]);

  return Response;
}(_body2.default);

exports.default = Response;